import Box from '@mui/material/Box';

import avatarImg from './avatar.jpg';
import { styles } from './style';

const Avatar = () => (
    <Box sx={styles.layout}>
        <Box component="img" sx={styles.img} src={avatarImg} alt="Mark Slepkov"/>
    </Box>
);

export default Avatar;
